import React from "react";
import {inject, observer} from "mobx-react";
import ReactCrop from "react-image-crop";
import "../../../styles/onboardingStep1.css";
import "../onboarding/onboarding3.css";
import Modal from "react-bulma-components/lib/components/modal";
import "react-image-crop/dist/ReactCrop.css";
import Button from "react-bulma-components/lib/components/button";
import "../../../styles/uploadimage.css";
import {base64StringtoFile, extractImageFileExtensionFromBase64, image64toCanvasRef} from "../../../helpers/reusable";
import "../../../styles/myProfile.css";
import {Redirect} from "react-router-dom";
import {
    validateIfInputHasCharacters,
    validateIfInputHasCharactersAllowSpaces,
    validateIfInputHasEmail,
    validateIfInputHasSpaces,
    validateIfInputHasUpperCaseLetter,
    validateIfInputHasYourMasterpieces,
    validateIfInputIsEmail,
    validateInputLength
} from "../../../helpers/validationChecks";
// import { base64StringtoFile, extractImageFileExtensionFromBase64, image64toCanvasRef } from "../../../helpers/reusable";
import resizer from "image-resizer-js";

import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";
import {CountryDropdown} from "react-country-region-selector";
import agent from "../../../api/agent";
import OB1 from '../onboarding/onboarding1-modal';
import OB2 from '../onboarding/onboarding2-modal';
import OB3 from '../onboarding/onboarding3-modal';
import ReactGA from "react-ga";

var dataFormatter = ""
var dsMain = "21/01/1990";
// // console.log("testDate");
const getInitialState = () => ({

    imageCropped: false,
    showCropMode: false,
    cropDetails: {},
    modifiedImages: [],
    modifiedImagesThumbnail: [],
    selectedOriginalImageUrl: '',
    selectedOriginalImage: null,
    selectedFile: null,
    wantsToEditInterest: false,
    wantsToEditStylePreferences: false,
    savedDetails: false,
    myFinalImage: {},
    currencySelected: '',
    formInputs: {
        full_name: "",
        display_name: "",
        bio: "",
        city: "",
        country: "",
        tags: "",
        email: "",
        preferences: "",
        interests: "",
        preferred_currency: "",
        dob: false,
        old_display_name: ""
    },
    dob: {
        day: "",
        month: "",
        year: ""
    }
});


const MAX_IMAGES = 1;
const year = (new Date()).getFullYear();
const years = Array.from(new Array(2000), (val, index) => -index + year - 12);
const months = []
const days_31 = []
const days_30 = []
const days_28 = []
const Months = [
    { display: "January", key: "01" },
    { display: "February", key: "02" },
    { display: "March", key: "03" },
    { display: "April", key: "04" },
    { display: "May", key: "05" },
    { display: "June", key: "06" },
    { display: "July", key: "07" },
    { display: "August", key: "08" },
    { display: "September", key: "09" },
    { display: "October", key: "10" },
    { display: "November", key: "11" },
    { display: "December", key: "12" },
]
@inject('userStore', 'navigatorStore', 'authStore', 'commonStore', 'generalStore')
@observer
export default class EditProfile extends React.Component {

    constructor(props) {
        super(props);
        this.imagePreviewCanvasRef = React.createRef()
        this.state = getInitialState();
        // this.handleDateChange = this.handleDateChange.bind(this);
    }


    handleChangeDOBDay(event) {
        // // console.log("year", event.target.value);
        this.setState({
            dob: {
                ...this.state.dob,
                day: event.target.value
            }
        })
    }
    handleChangeDOBMonth(event) {
        // // console.log("year", event.target.value);
        this.setState({
            dob: {
                ...this.state.dob,
                month: event.target.value
            }
        })
    }
    handleChangeDOBYear(event) {
        // // console.log("year", event.target.value);
        this.setState({
            dob: {
                ...this.state.dob,
                year: event.target.value
            }
        })
    }
    handleDayChange(datetest) {
        // console.log("this is the changed date", datetest)
        var dateToSendObj = moment(new Date(datetest))

        var dateToSendString = `${dateToSendObj.format("YYYY-MM-DD")}`
        // console.log("this is the changed date", dateToSendString)
        this.setState({
            formattedDateToSend: dateToSendString,
            dateProp: datetest,
        })

    }
    // formatDate(date, format, locale) {
    //     return dateFnsFormat(date, format, { locale });
    // }
    handleArtRequestsToggle() {
        this.setState({
            formInputs: {
                ...this.state.formInputs,
                commission_work: !this.state.formInputs.commission_work
            }
        }, () => {
            // localStorage.setItem("edited_country", this.state.formInputs.commission_work)
        }
        )
    }
    componentDidMount() {
        ReactGA.pageview('/Edit profile screen');
        if (localStorage.hasOwnProperty("userData")) {
            this.props.userStore.pulluser()
                .then((response) => {
                    // console.log(response);
                    var isDOBProvided = (!!response.data[0].dob && !response.data[0].dob.includes("null"))
                    var date;
                    // if (isDOBProvided) {
                    //     var ds = response.data[0].dob;
                    //     // console.log("date", ds)
                    //     date = moment(ds, ds.includes("/") ? "dd/MM/yyyy" : "dd MMMM yyyy");
                    // }
                    if (!response.data[0].display_name && !!response.data[0].old_display_name) {
                        if ((response.data[0].old_display_name) && !validateInputLength(response.data[0].old_display_name, 6, 30)) {
                            // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                            this.setState({
                                onboardingThreeIncomplete: true
                            })
                            return;
                        }
                        if ((response.data[0].old_display_name) && !validateIfInputHasSpaces(response.data[0].old_display_name, 6, 30)) {
                            // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                            this.setState({
                                onboardingThreeIncomplete: true
                            })
                            return;
                        }
                        if ((response.data[0].old_display_name) && validateIfInputHasCharacters(response.data[0].old_display_name)) {
                            // this.props.navigatorStore.openErrorModal("username can not contain characters");
                            this.setState({
                                onboardingThreeIncomplete: true
                            })
                            return;
                        }
                        if ((response.data[0].old_display_name) && validateIfInputHasUpperCaseLetter(response.data[0].old_display_name)) {
                            // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                            this.setState({
                                onboardingThreeIncomplete: true
                            })
                            return;
                        }
                        if ((response.data[0].old_display_name) && validateIfInputHasYourMasterpieces(response.data[0].old_display_name)) {
                            // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                            this.setState({
                                onboardingThreeIncomplete: true
                            })
                            return;
                        }
                        var formData = new FormData();
                        if (this.state.formInputs) formData.append("display_name", this.state.formInputs.display_name)
                        // if (!!this.state.formInputs.display_name && (this.state.curr_display_name != this.state.formInputs.display_name))
                        this.props.userStore.validateDisplayName(formData)
                            .then((response) => {
                                // console.log(response)
                                if (response.error == "True") {
                                    this.setState({
                                        onboardingThreeIncomplete: true,
                                        // formInputs: { ...this.state.formInputs, display_name: "" }
                                    })
                                    // this.props.navigatorStore.openErrorModal(response.data)
                                    return;
                                }
                                else {
                                    this.setState({
                                        onboardingThreeIncomplete: true
                                    })
                                }
                            })
                            .catch((err => {
                                this.setState({
                                    onboardingThreeIncomplete: true,
    
    
    
                                })
                            }));
                    }
    
                    if (response.data[0].display_name) {
                        if ((response.data[0].display_name) && !validateInputLength(response.data[0].display_name, 6, 30)) {
                            // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                            this.setState({
                                onboardingThreeIncomplete: true
                            })
                            return;
                        }
                        if ((response.data[0].display_name) && !validateIfInputHasSpaces(response.data[0].display_name, 6, 30)) {
                            // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                            this.setState({
                                onboardingThreeIncomplete: true
                            })
                            return;
                        }
                        if ((response.data[0].display_name) && validateIfInputHasCharacters(response.data[0].display_name)) {
                            // this.props.navigatorStore.openErrorModal("username can not contain characters");
                            this.setState({
                                onboardingThreeIncomplete: true
                            })
                            return;
                        }
                        if ((response.data[0].display_name) && validateIfInputHasUpperCaseLetter(response.data[0].display_name)) {
                            // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                            this.setState({
                                onboardingThreeIncomplete: true
                            })
                            return;
                        }
                        if ((response.data[0].display_name) && validateIfInputHasYourMasterpieces(response.data[0].display_name)) {
                            // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                            this.setState({
                                onboardingThreeIncomplete: true
                            })
                            return;
                        }
                    }
    
                    if (!response.data[0].full_name ||
                        !response.data[0].country ||
                        //  !response.data.user_profile[0].full_name || 
                        //  !response.data.user_profile[0].user.email || 
                        //  !response.data.user_profile[0].display_name || 
                        !response.data[0].display_name ||
                        response.data[0].display_name.length >= 30 ||
                        !response.data[0].primary_email ||
                        !response.data[0].preferred_currency
    
                    ) {
                        // console.log("profile null")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        // this.state.makeOnboardingThreeIncomplete()
                    }
    
                    
                    // console.log("datemain", date);
                    this.setState({
                        curr_display_name: (response.data[0].display_name) ? response.data[0].display_name : response.data[0].old_display_name,
                        curr_dob: response.data[0].dob,

                        dob: {
                            day: response.data[0].dob && response.data[0].dob.split("-")[2],
                            month: response.data[0].dob && response.data[0].dob.split("-")[1],
                            year: response.data[0].dob && response.data[0].dob.split("-")[0],
                        },
                        formInputs: {
                            ...this.state.formInputs,
                            image: response.data[0].image || (localStorage.hasOwnProperty("fb_id") && `http://graph.facebook.com/${localStorage.getItem("fb_id")}/picture?type=large`),
                            full_name: response.data[0].full_name,
                            display_name: (response.data[0].display_name) ? response.data[0].display_name : response.data[0].old_display_name,
                            country: response.data[0].country,
                            primary_email: ((!response.data[0].primary_email) ||
                                response.data[0].primary_email.includes("somerandomemail") ?
                                localStorage.hasOwnProperty("fb_email") ?
                                    localStorage.getItem("fb_email") :
                                    localStorage.hasOwnProperty("goog_email") ?
                                        localStorage.getItem("goog_email") :

                                        localStorage.getItem("login_email") :
                                response.data[0].primary_email),
                            bio: response.data[0].bio,
                            city: response.data[0].city,
                            tags: response.data[0].tags,
                            preferences: response.data[0].preferences,
                            interests: response.data[0].interests,

                            preferred_currency: response.data[0].preferred_currency,
                            gender: response.data[0].gender,
                            commission_work: response.data[0].commission_work,
                            email_verified: response.data[0].email_verified,
                            // old_display_name: response.data[0].old_display_name,
                        }
                    }, () => this.handleDisplayNameBlurr)
                })
        } else {
            this.props.navigatorStore.openSignInModal();
        }
    }
    onCloseCrop() {
        this.setState({ showCropMode: false });
    }

    showImage(event) {
        // console.log("[showImage] ", event.target.name);
        // let reader = new FileReader();
        var currentFile = event.target.files[0];
        var originalImageUrl = URL.createObjectURL(currentFile);
        this.setState({
            showCropMode: true,
            selectedOriginalImage: currentFile,
            selectedOriginalImageUrl: originalImageUrl,
        })
    }

    saveDetails(some, hideLoader) {
        // console.log("date", this.state.formInputs.dob)
        if (!hideLoader) {
            if (!this.state.formInputs.display_name) {
                this.props.navigatorStore.openErrorModal("Please enter your username");
                this.setState({
                    displayNameValid: "invalid"
                })
                return;
            }
            if ((this.state.formInputs.display_name) && !validateInputLength(this.state.formInputs.display_name, 6, 30)) {
                this.props.navigatorStore.openErrorModal("Username must be between 6 and 30 characters long");
                this.setState({
                    displayNameValid: "invalid"
                })
                return;
            }
            if ((this.state.formInputs.display_name) && !validateIfInputHasSpaces(this.state.formInputs.display_name)) {
                this.props.navigatorStore.openErrorModal("Username cannot contain spaces, special characters or uppercase letters")
                this.setState({
                    displayNameValid: "invalid"
                })
                return;
            }
            if ((this.state.formInputs.display_name) && validateIfInputHasCharacters(this.state.formInputs.display_name)) {
                this.props.navigatorStore.openErrorModal("Username cannot contain spaces, special characters or uppercase letters");
                this.setState({
                    displayNameValid: "invalid"
                })
                return;
            }
            if ((this.state.formInputs.display_name) && validateIfInputHasUpperCaseLetter(this.state.formInputs.display_name)) {
                this.props.navigatorStore.openErrorModal("Username cannot contain spaces, special characters or uppercase letters")
                this.setState({
                    displayNameValid: "invalid"
                })
                return;
            }
            if ((this.state.formInputs.display_name) && validateIfInputHasYourMasterpieces(this.state.formInputs.display_name)) {
                this.props.navigatorStore.openErrorModal("Username must not contain 'yourmasterpieces'")
                this.setState({
                    displayNameValid: "invalid"
                })
                return;
            }
            if (!this.state.formInputs.full_name) {
                this.props.navigatorStore.openErrorModal("Name must be between 2 to 150 characters");
                return;
            }
            if ((this.state.formInputs.full_name) && !validateIfInputHasCharactersAllowSpaces(this.state.formInputs.full_name)) {
                this.props.navigatorStore.openErrorModal("Name cannot contain special characters");
                return;
            }
            if ((!!this.state.formInputs.city) && !validateIfInputHasCharactersAllowSpaces(this.state.formInputs.city)) {
                this.props.navigatorStore.openErrorModal("City cannot contain special characters");
                return;
            }

            if (!this.state.formInputs.country || this.state.formInputs.country.length == 0) {
                this.props.navigatorStore.openErrorModal("Please select the country");
                return;
            }
            if (!this.state.formInputs.preferred_currency || this.state.formInputs.preferred_currency.length == 0) {
                this.props.navigatorStore.openErrorModal("Please select your preferred currency");
                return;
            }
            if (!this.state.formInputs.primary_email) {
                this.props.navigatorStore.openErrorModal("Please enter your communication email");
                return;
            }


            // if (!validateInputLength(this.state.formInputs.bio, 0, 750)) {
            //       this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
            //     return;
            // }


            // if (this.state.formInputs.country == 0) {
            //     this.props.navigatorStore.openErrorModal("Please select your country");
            //     return;
            // }
            if ((!this.state.formInputs.primary_email) || !validateIfInputIsEmail(this.state.formInputs.primary_email)) {
                this.props.navigatorStore.openErrorModal("Please enter a valid email.");
                return;
            }
            if ((this.state.formInputs.bio) && this.state.formInputs.bio.length > 750) {
                this.props.navigatorStore.openErrorModal("Bio must not exceed 750 characters");

                return;
            }
            if (!this.state.formInputs.gender) {
                this.props.navigatorStore.openErrorModal("Gender is mandatory");

                return;
            }
            if (!this.state.formInputs.dob && !this.state.dob.day) {
                this.props.navigatorStore.openErrorModal("Date of birth is mandatory");

                return;
            }
            if ((this.state.formInputs.bio) && validateIfInputHasEmail(this.state.formInputs.bio)) {
                this.props.navigatorStore.openErrorModal("Bio must not contain any email id, phone number or any other contact details")

                return;
            }
        }
        ReactGA.pageview('/Edit profile update action');
        let _scope = this;
        var ds = `${this.state.formInputs.dob}`;
        var dateM = moment(new Date(ds.substr(4, 16)), "MMM dd yyyy");
        var dates = dateM.format("dd MMMM yyyy")
        // console.log("date.format", new Date(ds.substr(0, 16)), dates);
        // var dateF = dateM._i

        if (dates == "Invalid date") {
            dates = this.state.curr_dob
        }
        // // console.log(dateF)
        var dobToSend = `${this.state.dob.year}-${this.state.dob.month}-${this.state.dob.day}`
        var formData = new FormData();
        if (!this.state.modifiedImages.url) {
            // console.log("without the image edit")
            // (this.state.myFinalImage) ? formData.append("image", this.state.myFinalImage, "myFile.png") : "";
            formData.append("country", this.state.formInputs.country)
            formData.append("city", this.state.formInputs.city || "")
            formData.append("full_name", this.state.formInputs.full_name);
            (this.state.curr_display_name == this.state.formInputs.display_name) ? "" : formData.append("display_name", this.state.formInputs.display_name);
            formData.append("bio", this.state.formInputs.bio)
            formData.append("dob", dobToSend)
            formData.append("primary_email", this.state.formInputs.primary_email)
            formData.append("tags", this.state.formInputs.tags)
            formData.append("gender", this.state.formInputs.gender)
            formData.append("commission_work", (this.state.formInputs.commission_work) ? "True" : "False")
            formData.append("preferred_currency", this.state.formInputs.preferred_currency)
            !!this.props.navigatorStore.editedInterestsToDisplay && formData.append("interests", this.props.navigatorStore.editedInterestsToDisplay)
            !!this.props.navigatorStore.editedPreferencesToDisplay && formData.append("preferences", this.props.navigatorStore.editedPreferencesToDisplay)
            localStorage.setItem("preferred_currency", this.state.formInputs.preferred_currency)
            // for (var key in this.state.formInputs) {
            //     formData.append(key, this.state.formInputs[key]);
            // }
            this.props.userStore.requestToEditUser(formData, null, false, hideLoader)
                .then((response) => {
                    // localStorage.removeItem("edited_preferred_currency")
                    // localStorage.removeItem("edited_country")
                    // localStorage.removeItem("edited_full_name")
                    // localStorage.removeItem("edited_gender")
                    // localStorage.removeItem("edited_city")
                    // localStorage.removeItem("edited_country")
                    // localStorage.removeItem("edited_month")
                    // localStorage.removeItem("edited_bio")
                    // localStorage.removeItem("editedPreference")
                    // localStorage.removeItem("editedInterest")
                    // localStorage.removeItem("edited_primary_email")
                    // localStorage.removeItem("edited_commission_work")
                    !hideLoader && this.props.navigatorStore.displayEditedInterests("")
                    !hideLoader && this.props.navigatorStore.displayEditedPreferences("")
                    // console.log(response)
                    this.setState({
                        savedDetails: hideLoader ? false : true,
                        changedSomething: false,

                    })
                })


        }

        else {
            // let imageProcessPromises = _scope.state.modifiedImages.map(fileDetailObj => 
            _scope.resizeAndUploadOneImage(_scope.state.modifiedImages,"image");
            _scope.resizeAndUploadOneImage(_scope.state.modifiedImagesThumbnail,"timg");
        }

    }
    handleOnCropChange = (cropDetails) => {
        this.setState({ cropDetails })
    }
    handleOnCropComplete = (crop, pixelCrop) => {
        // console.log("[crop complete]", pixelCrop);

        const canvasRef = this.imagePreviewCanvasRef.current
        image64toCanvasRef(canvasRef, this.state.selectedOriginalImageUrl, pixelCrop);
        this.setState({
            imageCropped: true,
        })
    }
    handleImageLoaded = (image) => {
        this.setState({
            // selectedOriginalImage: image
        })
    }
    onImageCropDone() {
        this.setState({
            preview: ""
        })
        const scope = this;
        scope.onCloseCrop();
        const canvasRef = this.imagePreviewCanvasRef.current
        // console.log("this.state.selectedOriginalImageUrlthis.state.selectedOriginalImageUrl", this.state.selectedOriginalImageUrl)
        const imageData64 = canvasRef.toDataURL('image/' + extractImageFileExtensionFromBase64(this.state.selectedOriginalImageUrl))
        // const myFilename = this.state.file
        const myNewCroppedFile = base64StringtoFile(imageData64, "unnamed_file_2.png");
        // // console.log("myNewCroppedFilenm", this.state.imageCropped, myNewCroppedFile);
        const imageUrl = URL.createObjectURL(myNewCroppedFile)
        // // console.log("FileUrl", myNewCroppedFile.name)
        // // console.log(this.state.crop)
        if (this.state.imageCropped) {
            // Initiate the JavaScript Image object.
            var image = new Image();
            // Set the Base64 string return from FileReader as source.
            image.src = imageUrl;
            image.onload = () => {
                var height = image.height;
                var width = image.width;
                // // console.log("cropped dimensions", height, width)
                scope.setState({
                    selectedCroppedImage: myNewCroppedFile,
                    selectedCroppedImageUrl: imageUrl,
                    cropDetails: {},
                    imageCropped: false
                }, () => {
                    scope.validateImageDimensions(height, width);
                })
            }
        }
        else {
            var image = new Image();
            image.src = scope.state.selectedOriginalImageUrl;
            image.onload = () => {
                var height = image.height;
                var width = image.width;
                scope.setState({
                    selectedCroppedImage: scope.state.selectedOriginalImage,
                    selectedCroppedImageUrl: scope.state.selectedOriginalImageUrl,
                }, () => {
                    scope.validateImageDimensions(height, width);
                });
            }
        }
    }

    validateImageDimensions(height, width) {
        // console.log("selectedCroppedImage", this.state.selectedCroppedImage)
        // console.log("[validateImageDimensions] image dimensions", height, width)
        if ((height >= width && height < 512) || (width >= height && width < 512)) {
            this.props.navigatorStore.openErrorModal("Please upload picture of size greater than 512x512 px");
            this.onImageReject();
            return;
        }
        let newHeight = height;
        let newWidth = width;
        if (width >= height && width > 1080) {
            newWidth = 1080
            newHeight = (height / width) * newWidth;
        }
        else if (height >= width && height > 1080) {
            newHeight = 1080
            newWidth = (width / height) * newHeight;
        }
        this.onImageAccept(newHeight, newWidth);
    }

    onImageAccept(newHeight, newWidth) {
        // console.log("[onImageAccept]", newHeight, newWidth)
        this.setState({
            modifiedImages:
            // this.state.modifiedImages.concat(
            {
                url: this.state.selectedCroppedImageUrl,
                img: this.state.selectedCroppedImage,
                height: newHeight,
                width: newWidth,
            }
            // )

            ,

            selectedCroppedImageUrl: null,
            selectedCroppedImage: null,
            selectedOriginalImage: null,
            selectedOriginalImageUrl: null,
            crop: null
            // finalImageHeight: newHeight,
            // finalImageWidth: newWidth
        }, () => {
            // console.log("did set the new height and width", this.state)
        })
        this.setState({
            modifiedImagesThumbnail:
            // this.state.modifiedImages.concat(
            {
                url: this.state.selectedCroppedImageUrl,
                img: this.state.selectedCroppedImage,
                height: 500,
                width: 500,
            }})
    }

    onImageReject() {
        let { selectedCroppedImageUrl, selectedCroppedImage } = getInitialState();
        this.setState({
            selectedCroppedImageUrl, selectedCroppedImage, imageCropped: false,
            cropDetails: {},

        }

        )



    }
    handleInputChange(event) {
        // localStorage.setItem(`edited_${event.target.name}`, event.target.value)
        this.setState(
            {
                changedSomething: true,
                formInputs: { ...this.state.formInputs, [event.target.name]: event.target.value }
            }, () => {
                // console.log("changed the input box ", this.state.formInputs);
            })
    }

    handleSaveClick(hideLoader) {
        // console.log("with the image edit")

        let _scope = this;
        let imageProcessPromises = _scope.state.modifiedImages.map(fileDetailObj => _scope.resizeAndUploadOneImage(fileDetailObj, "image"));
        let imageProcessPromisesThumbnail = _scope.state.modifiedImagesThumbnail.map(fileDetailObj => _scope.resizeAndUploadOneImage(fileDetailObj,  "timg"));
        Promise.all(imageProcessPromises).then(resolutions => {
            // console.log("resolutions = ", resolutions);
            // this.props.navigatorStore.openErrorModal("SUCCESS!!");
            // _scope.setState({
            //     submittedImages: true
            // })
        }).catch(issueInUploading => {
            // console.log(issueInUploading);
            this.props.navigatorStore.openErrorModal("Error Uploading Image ")
        })
        .then(()=>{
            Promise.all(imageProcessPromisesThumbnail).then(resolutions => {
                // console.log("resolutions = ", resolutions);
                // this.props.navigatorStore.openErrorModal("SUCCESS!!");
                _scope.setState({
                    submittedImages: true
                })
            }).catch(issueInUploading => {
                // console.log(issueInUploading);
                this.props.navigatorStore.openErrorModal("Error Uploading Image ")
            })
        })
    }

    resizeAndUploadOneImage(fileDetailObj,key, callback) {
        let _scope = this;
        console.log("[key]",key)
        return new Promise((resolve, reject) => {
            const options = {
                maxWidth: fileDetailObj.width,
                maxHeight: fileDetailObj.height,
            }
            const fileReader = new FileReader();
            // // console.log("with width and height", _scope.state.finalImageWidth, _scope.state.finalImageHeight);
            let arrayBuffer;
            fileReader.onload = function (event) {
                // // console.log("with width and height", options);
                arrayBuffer = event.target.result;
                resizer(arrayBuffer, options)
                    .then(image => {
                        var ds = `${_scope.state.formInputs.dob}`;
                        var dateM = moment(new Date(ds.substr(4, 16)), "MMM dd yyyy");
                        var dates = dateM.format("dd MMMM yyyy")
                        // console.log("date.format", new Date(ds.substr(0, 16)), dates);
                        // var dateF = dateM._i

                        if (dates == "Invalid date") {
                            dates = _scope.state.curr_dob
                        }
                        // // console.log("img ", image)
                        // // console.log("with width and height", _scope.state.finalImageWidth, _scope.state.finalImageHeight);
                        // image resized
                        const blob = new Blob([image], { type: 'image/png' });
                        // const blob = new Blob([image]);
                        image.src = blob;
                        var formData = new FormData();
                        _scope.setState({
                            myFinalImage: blob
                        })
                        var dobToSend = `${_scope.state.dob.year}-${_scope.state.dob.month}-${_scope.state.dob.day}`
                        formData.append(key, blob, "myFile.png");
                        formData.append("country", _scope.state.formInputs.country)
                        formData.append("city", _scope.state.formInputs.city || "")
                        formData.append("full_name", _scope.state.formInputs.full_name);
                        (_scope.state.curr_display_name == _scope.state.formInputs.display_name) ? "" : formData.append("display_name", _scope.state.formInputs.display_name);
                        formData.append("bio", _scope.state.formInputs.bio)
                        formData.append("dob", dobToSend)
                        formData.append("primary_email", _scope.state.formInputs.primary_email)
                        formData.append("tags", _scope.state.formInputs.tags)
                        formData.append("gender", _scope.state.formInputs.gender)
                        formData.append("commission_work", _scope.state.formInputs.commission_work)
                        formData.append("preferred_currency", _scope.state.formInputs.preferred_currency)
                        formData.append("image_uploaded", true);
                        !!_scope.props.navigatorStore.editedInterestsToDisplay ? formData.append("interests", _scope.props.navigatorStore.editedInterestsToDisplay) : ""
                        !!_scope.props.navigatorStore.editedPreferencesToDisplay ? formData.append("preferences", _scope.props.navigatorStore.editedPreferencesToDisplay) : ""
                        localStorage.setItem("preferred_currency", _scope.state.formInputs.preferred_currency)
                        _scope.props.userStore.requestToEditUser(formData, null, true, _scope.state.editingSave)
                            .then((response) => {
                                // console.log("[ropic ", response)
                                _scope.setState({
                                    savedDetails: (_scope.state.editingSave) ? false : true,
                                    changedSomething: false,
                                    formInputs: {
                                        ..._scope.state.formInputs,
                                        image: response.data.image
                                    }
                                },
                                    function () {
                                        window.localStorage.setItem('image', _scope.state.formInputs.image)
                                        _scope.props.userStore.pulluser()
                                    })
                            })
                    })
                // .catch(reject)
            };
            fileReader.readAsArrayBuffer(fileDetailObj.img);
        })
    }


    showImage(event) {
        // console.log("[showImage] ", event.target.name);
        // let reader = new FileReader();
        var currentFile = event.target.files[0];
        var originalImageUrl = URL.createObjectURL(currentFile);
        this.setState({
            showCropMode: true,
            selectedOriginalImage: currentFile,
            selectedOriginalImageUrl: originalImageUrl,
        })
    }
    componentWillUnmount() {
        // console.log("unmounting")
        // if (this.state.changedSomething) {
        this.props.navigatorStore.closeOB1Modal()
        this.props.navigatorStore.closeOB2Modal()
        // this.props.navigatorStore.openErrorModal("Are you sure you want to leave? Your changes will not be saved !", true)
        // }
    }
    handleEditInterestsClick() {
        this.setState({
            editingSave: true
        }, () => {
            this.saveDetails(this, true)

        })
        this.props.navigatorStore.openOB1Modal(true)
    }

    handleEditStylePrefsClick() {
        this.setState({
            editingSave: true
        }, () => {
            this.saveDetails(this, true)

        })
        this.props.navigatorStore.openOB2Modal(true)
    }

    selectCountry(item) {
        this.setState({
            changedSomething: true,
            formInputs: {
                ...this.state.formInputs,
                country: item
            }
        }, () => {
            // localStorage.setItem("edited_country", item)
        })
    }
    handleCurrencySelection(currencyAbbrevation) {
        // console.log(`Selected ${currencyAbbrevation}`);
        this.setState({
            changedSomething: true,
            formInputs: { ...this.state.formInputs, preferred_currency: currencyAbbrevation.target.value }
        }, function () {
            // localStorage.setItem("edited_preferred_currency", currencyAbbrevation)
        })
    }



    handleDateChange(date) {
        // console.log(typeof date);
        debugger;
        this.setState({
            changedSomething: true,
            formInputs: {
                ...this.state.formInputs,
                dob: date
            }
        }, function () {
            // console.log(this.state.formInputs)
        })
    }


    handleChangePassword() {
        this.saveDetails(this, true)
        this.setState({
            navigateToUpdatePwd: true,
            editingSave: true
        })
    }

    setDateInState() {
        this.setState({
            formInputs: {
                ...this.state.formInputs,
                dob: `${dataFormatter}`
            }
        }, function () {

            // console.log(this.state.formInputs)

        })
    }
    handleGenderChange(event) {
        this.setState({
            changedSomething: true,
            formInputs: {
                ...this.state.formInputs,
                gender: event.target.value
            }
        })
    }
    handleCommissionWork(event) {
        this.setState({
            changedSomething: true,
            formInputs: {
                ...this.state.formInputs,
                commission_work: event.target.value
            }
        }, () => {
            // localStorage.setItem("edited_commission_work",  event.target.value )
        })
    }


    sendVerificationEmail() {
        agent.Auth.sendEmailVerification(localStorage.getItem("profile_id"))
            .then((res) => {
                // console.log(res);
                this.props.navigatorStore.openErrorModal(res.message, false, null, true)
            })
    }

    tempDisplayName(event) {
        this.setState({
            formInputs: { ...this.state.formInputs, display_name: event.target.value }
        }, () => {
            // console.log(this.state.tempDisplayName)
        })
    }
    handleDisplayNameBlurr() {
        if ((this.state.formInputs.display_name) && !validateInputLength(this.state.formInputs.display_name, 6, 30)) {
            this.props.navigatorStore.openErrorModal("Username must be between 6 and 30 characters long");
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        if ((this.state.formInputs.display_name) && !validateIfInputHasSpaces(this.state.formInputs.display_name, 6, 30)) {
            this.props.navigatorStore.openErrorModal("Username cannot contain spaces, special characters or uppercase letters")
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        if ((this.state.formInputs.display_name) && validateIfInputHasCharacters(this.state.formInputs.display_name)) {
            this.props.navigatorStore.openErrorModal("Username cannot contain spaces, special characters or uppercase letters");
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        if ((this.state.formInputs.display_name) && validateIfInputHasUpperCaseLetter(this.state.formInputs.display_name)) {
            this.props.navigatorStore.openErrorModal("Username cannot contain spaces, special characters or uppercase letters")
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        if ((this.state.formInputs.display_name) && validateIfInputHasYourMasterpieces(this.state.formInputs.display_name)) {
            this.props.navigatorStore.openErrorModal("Username must not contain 'yourmasterpieces'")
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        var formData = new FormData();
        formData.append("display_name", this.state.formInputs.display_name)
        if (!!this.state.formInputs.display_name && (this.state.curr_display_name != this.state.formInputs.display_name))
            this.props.userStore.validateDisplayName(formData)
                .then((response) => {
                    // console.log(response)
                    if (response.error == "True") {
                        this.setState({
                            displayNameValid: "invalid",
                            formInputs: { ...this.state.formInputs, display_name: "" }
                        })
                        this.props.navigatorStore.openErrorModal(response.data)
                        // return;
                    }
                    else {
                        this.setState({
                            displayNameValid: "valid",
                        }, window.localStorage.setItem('display_name', this.state.formInputs.display_name),
                            window.localStorage.setItem('username', this.state.formInputs.display_name),
                            this.props.userStore.pulluser())
                    }
                })
                .catch((err => {
                    this.setState({
                        displayNameValid: "invalid",

                        formInputs: { ...this.state.formInputs, display_name: "" }
                    }, this.props.navigatorStore.openErrorModal("Sorry, this username is not available "))
                }));
    }
    render() {
        const FORMAT = 'dd MMMM yyyy';
        // console.log(React.version);
        for (var i = 1; i <= 31; i++) {
            days_31.push(i < 10 ? ("0" + i.toString()) : i.toString());
        }
        for (var i = 1; i <= 30; i++) {
            days_30.push(i < 10 ? ("0" + i.toString()) : i.toString());
        }
        for (var i = 1; i <= 30; i++) {
            days_28.push(i < 10 ? ("0" + i.toString()) : i.toString());
        }

        if (
            localStorage.hasOwnProperty("userData") &&
            ((this.props.authStore.RegisterSuccess &&
                (!this.props.authStore.onboardingThreeIncomplete && !localStorage.getItem("registerDone")))
                || localStorage.getItem("just_registered"))

        ) {

            this.props.authStore.resetRegisterSuccess();
            localStorage.removeItem("just_registered")
            // console.log("registered, still ")
            // console.log("identifier redirecting to onboardingThree ", this.props.authStore.updateComplete, this.props.authStore.onboardingThreeIncomplete);
            return (
                <Redirect push to='/onboardingone' />
            )
        }


        if (
            (window.localStorage.hasOwnProperty("userData") && !localStorage.getItem("registerDone") && !this.props.authStore.RegisterSuccess &&
                (this.state.onboardingThreeIncomplete || ((this.props.authStore.loginDone) &&
                    this.props.authStore.onboardingThreeIncomplete)))
            || localStorage.getItem("incompleteOnboardingThree")
        ) {
            // console.log("identifier redirecting to onboardingThree ", this.props.authStore.updateComplete, this.props.authStore.onboardingThreeIncomplete);
            this.props.authStore.resetLoginDone();
            this.props.authStore.resetUpdateComplete();
            localStorage.removeItem("incompleteOnboardingThree")
            return (
                <Redirect push to="/onboardingthree"></Redirect>
            )
        }
        if (this.state.wantsToEditInterest) {
            return (
                <Redirect push to="/edit-interests" />
            )
        }
        if (this.state.wantsToEditStylePreferences) {

            return (
                <Redirect push to="/edit-style-preferences" />
            )
        }
        if (this.state.savedDetails) {
            return (
                <Redirect push to={`/profile/details/${localStorage.getItem("username")}`} />
            )
        }
        if (this.state.navigateToUpdatePwd) {

            return (
                <Redirect push to="/updatepassword" />
            )
        }
        return (
            <div className="back">
                <Modal show={this.state.showCropMode} onClose={this.onCloseCrop.bind(this)} >
                    <Modal.Content>
                        <div className="crop-screen-header">
                            <p className="crop-screen-heading">CROP
                                <img onClick={this.onCloseCrop.bind(this)} className="cross-icon-for-modal" src={require('../../../assets/cross_icon_for_close.png')}></img></p>
                        </div>
                        <div className="crop-screen-image">
                            <ReactCrop
                                src={this.state.selectedOriginalImageUrl}
                                crop={this.state.cropDetails}
                                onImageLoaded={this.handleImageLoaded.bind(this)}
                                onComplete={this.handleOnCropComplete.bind(this)}
                                onChange={this.handleOnCropChange.bind(this)}
                            />
                        </div>

                        <canvas style={{ display: "none" }} ref={this.imagePreviewCanvasRef}></canvas>
                        <Button className="masterpieces-primary-buttons" id="crop-screen-button" onClick={this.onImageCropDone.bind(this)}><p style={{ fontFamily: "Montserrat", color: "#FFFFFF" }}>Done</p></Button>
                    </Modal.Content>
                </Modal>
                <div className="heading-welcome">
                    EDIT PROFILE
                    <hr className="line-category-name margin-auto"></hr>
                </div>
                <div className="container onboardingStep3 editProfile onboarding-container">
                    <div className="content-onboarding-step">
                        <div className="heading-text">
                            <div className="onboarding-question pl-15">
                                Basic Details
                            </div>
                        </div>
                        <OB1 />
                        <OB2 />
                        <OB3 />
                        <div className="user-photo-name-username">
                            <div className="user-profile-photo">
                                <img alt="" className="image-preview-profile-picture" src={this.state.modifiedImages.url || this.state.formInputs.image || require('../../../assets/default_picture.png')}   ></img>
                                {/* {this.state.modifiedImages.map((modifiedImage, imageIdx) => ( */}
                                {/* <img alt="" className="image-preview-profile-picture" src={this.state.modifiedImages.url || "http://yourmasterpieces.com/auth/user/images/edit_profile.png"}  ></img> */}
                                {/* ))} */}
                                <img src={require('../../../assets/pick_photo_tap_svg.svg')} className="select-photo-tap-icon" />
                                <input type="file" className="select-user-profile-photo" onChange={this.showImage.bind(this)} onClick={(event) => {
                                    event.target.value = null
                                }} accept="image/*"></input>
                            </div>
                            <div className="user-name-and-username">

                                <div className="form-element-user-profile">

                                    <div className="basic-info-text">
                                        Your username is your profile handle and your very personal art gallery online
                                    </div>
                                    <p className="form-section-name-user-profile">USERNAME

                                    <img style={{ display: (this.state.displayNameValid == "invalid") ? "" : "none" }} className="success-status-icon" src={require('../../../assets/cross.png')}  ></img>
                                        <img style={{ display: (this.state.displayNameValid == "valid") ? "" : "none" }} className="success-status-icon" src={require('../../../assets/success-icon.png')}  ></img></p>

                                    <input type="text"
                                        value={this.state.formInputs.display_name}
                                        name="display_name" onChange={this.tempDisplayName.bind(this)} required
                                        onBlur={this.handleDisplayNameBlurr.bind(this)}
                                        placeholder="Your username"
                                        className="form-element-small-input ml-15"></input>

                                    <div className="suggest-text">yourmasterpieces.com/{this.state.formInputs.display_name}</div>

                                </div>

                            </div>
                        </div>


                        <div className="user-profile-form-section">

                            <div className="profile-details-dropdown-container">

                                <div className="form-element-user-profile">
                                    <p className="form-section-name-user-profile">NAME</p>
                                    <input value={this.state.formInputs.full_name || localStorage.getItem("edited_full_name")} type="text" name="full_name"
                                        onChange={this.handleInputChange.bind(this)} required
                                        placeholder="Your name"
                                        className="form-element-small-input ml-15"></input>
                                </div>

                                <div className="profile-details-country-dropdown">
                                    <p className="form-section-name-user-profile">GENDER</p>
                                    <select value={this.state.formInputs.gender || localStorage.getItem("edited_gender")}
                                        placeholder="Gender"
                                        onChange={this.handleGenderChange.bind(this)} name="gender" className="w90">
                                        <option value="" style={{ display: "none" }}></option>
                                        <option value="MALE">Male</option>
                                        <option value="FEMALE">Female</option>
                                        <option value="OTHERS">Others</option>
                                    </select>
                                </div>


                            </div>


                            <div className="profile-details-dropdown-container">

                                <div className="form-element-user-profile">
                                    <p className="form-section-name-user-profile">CITY</p>
                                    <input type="text" name="city" required
                                        value={this.state.formInputs.city || localStorage.getItem("edited_city")}
                                        onChange={this.handleInputChange.bind(this)}
                                        placeholder="City (optional)"
                                        className="form-element-small-input ml-15">
                                    </input>
                                </div>

                                <div className="profile-details-country-dropdown">
                                    <p className="form-section-name-user-profile">COUNTRY</p>

                                    <CountryDropdown className="form-element-small-input ml-15 w90"
                                        value={this.state.formInputs.country || localStorage.getItem("edited_country")}
                                        placeholder="Select your country"
                                        onChange={(val) => this.selectCountry(val)} />
                                </div>
                            </div>

                            <div className="profile-details-dropdown-container mb-25">
                                <div className="col-md-12">
                                    <div className="profile-details-country-dropdown">
                                        <label className="form-section-name-user-profile ml-0">DATE OF BIRTH</label>
                                        {/* {
                                            !!this.state.formInputs.dob ?
                                                <DatePicker
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    // maxDate={addDays(new Date(), 4380)}
                                                    dateFormat="dd MMMM yyyy"
                                                    placeholderText="Date of birth"
                                                    selected={new Date(this.state.formInputs.dob)}
                                                    onChange={this.handleDateChange.bind(this)}
                                                />
                                                :
                                                <DatePicker
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    // maxDate={addDays(new Date(), 4380)}
                                                    dateFormat="dd MMMM yyyy"
                                                    placeholderText="Date of birth"
                                                    onChange={this.handleDateChange.bind(this)}
                                                />
                                        } */}
                                        {/* 
                                        <DayPickerInput
                                            // month={new Date(2015, 8)}
                                            value={(this.state.formInputs.dob) ? `${

                                                // this.state.formInputs.dob +
                                                moment(new Date(this.state.formInputs.dob)).format("DD MMMM YYYY")}` : "23 July 2018"}

                                            classNames="form-element-large-input-profile-details"
                                            formatDate={this.formatDate.bind(this)}
                                            format={FORMAT}
                                            dayPickerProps={{
                                                selectedDays: [this.state.dateProp]
                                            }}

                                            parseDate={this.parseDate.bind(this)}
                                            onDayChange={this.handleDayChange.bind(this)}
                                            onChange={this.handleDayChange.bind(this)}

                                        // placeholder={(this.state.formInputs.dob) ? `${

                                        //     // this.state.formInputs.dob +
                                        //     (moment(new Date(this.state.formInputs.dob))).format("DD MMMM YYYY")}` : "Date of birth"}

                                        /> */}
                                        <div className="profile-details-country-dropdown">
                                            <div className="row dob-select">
                                                <div className="col-md-4">

                                                    <select placeholder="MONTH"
                                                        className="form-element-small-input"
                                                        value={this.state.dob.month || localStorage.getItem("edited_month")}
                                                        onChange={this.handleChangeDOBMonth.bind(this)}>
                                                        <option style={{ display: "none" }}></option>
                                                        {
                                                            Months.map((el) => {
                                                                return (

                                                                    <option
                                                                        key={el + new Date().getTime() + Math.random()}
                                                                        value={el.key}>{el.display}</option>

                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-4">
                                                    <select placeholder="MONTH"
                                                        className="form-element-small-input"
                                                        value={this.state.dob.day || localStorage.getItem("edited_day")}
                                                        onChange={this.handleChangeDOBDay.bind(this)}>
                                                        <option style={{ display: "none" }}></option>
                                                        {
                                                            (this.state.dob.month == "February") ?
                                                                days_28.map((el) => {
                                                                    return (

                                                                        <option
                                                                            key={el + new Date().getTime() + Math.random()}
                                                                            value={el}>{el}</option>

                                                                    )
                                                                })
                                                                :
                                                                (
                                                                    (this.state.dob.month == "04") ||
                                                                    (this.state.dob.month == "04") ||
                                                                    (this.state.dob.month == "09") ||
                                                                    (this.state.dob.month == "11"))
                                                                    ?
                                                                    days_30.map((el) => {
                                                                        return (

                                                                            <option
                                                                                key={el + new Date().getTime() + Math.random()}
                                                                                value={el}>{el}</option>

                                                                        )
                                                                    })
                                                                    :

                                                                    days_31.map((el) => {
                                                                        return (

                                                                            <option
                                                                                key={el + new Date().getTime() + Math.random()}
                                                                                value={el}>{el}</option>

                                                                        )
                                                                    })

                                                        }
                                                    </select>

                                                </div>
                                                <div className="col-md-4">
                                                    <select className="form-element-small-input"
                                                        value={this.state.dob.year || localStorage.getItem("edited_year ")}
                                                        onChange={this.handleChangeDOBYear.bind(this)}>
                                                        <option></option>
                                                        {
                                                            years.map((year, index) => {
                                                                return (

                                                                    <option key={`year${index}`}
                                                                        value={year}>{year}</option>

                                                                )
                                                            })
                                                        }

                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        {/* className="form-element-small-input ml-3" */}
                                    </div>
                                </div>
                            </div>


                            <div className="form-element-user-profile" sytle={{ flex: 1 }}>
                                <p className="form-section-name-user-profile">BIO</p>
                                <textarea name="bio"
                                    value={this.state.formInputs.bio || localStorage.getItem("edited_bio ")}
                                    placeholder="Tell us a bit about yourself (optional)"
                                    onChange={this.handleInputChange.bind(this)} type="text" required
                                    className="form-element-large-input-profile-details"></textarea>
                            </div>



                            <div className="row mr-0 ml-0 ">
                                <div className="heading-text">
                                    <div className="onboarding-question pl-15">
                                        Preferences
                                        <br />
                                    </div>
                                </div>
                            </div>


                            <div className="row mr-0 ml-0 account-preferences">

                                <div className="col-md-6 pl-0">
                                    <div className="form-group">
                                        <p>
                                            <label htmlFor="usd">Style Preferences</label>
                                            <div onClick={this.handleEditStylePrefsClick.bind(this)}
                                                className="input-text" type="number" name="style"><p
                                                    className="input-field-values">{!!this.props.navigatorStore.editedPreferencesToDisplay ? this.props.navigatorStore.editedPreferencesToDisplay : this.state.formInputs.preferences || "Your tastes"}</p>
                                            </div>
                                        </p>
                                    </div>
                                </div>

                                <div className="col-md-6 pl-0">
                                    <div className="form-group">
                                        <p>
                                            <label htmlFor="usd">Interests</label>
                                            <div onClick={this.handleEditInterestsClick.bind(this)}
                                                className="input-text" type="number" name="style"><p
                                                    className="input-field-values">{!!this.props.navigatorStore.editedInterestsToDisplay ? this.props.navigatorStore.editedInterestsToDisplay : this.state.formInputs.interests || "Your interests"}</p>
                                            </div>

                                            {/* <input onClick={this.handleEditInterestsClick.bind(this)} className="input-text"  type="text" name="interest" /> */}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="row mr-0 ml-0 account-preferences">
                                <div className="col-md-6 pl-0">
                                    <div className="form-group">
                                        <p>
                                            <label htmlFor="currency">PREFERRED CURRENCY</label>
                                            <select value={this.state.formInputs.preferred_currency || localStorage.getItem("edited_preferred_currency")}
                                                onChange={this.handleCurrencySelection.bind(this)}
                                                placeholder="Preferred currency"
                                                className="w100">
                                                <option style={{ display: "none" }} disabled> Select Currency</option>
                                                {
                                                    this.props.generalStore.Currencies.map((el, idx) =>
                                                        <option value={el.key}>{el.display}</option>
                                                    )
                                                }
                                            </select>
                                        </p>
                                    </div>
                                </div>

                                <div className="col-md-6 pl-0">
                                    <div className="form-group">
                                        <p>
                                            <label htmlFor="primary_email">COMMUNICATION EMAIL<span className="text-capitalize" style={{ display: (this.state.formInputs.email_verified) ? "none" : "", color: "#D0021B" }}>(Unverified)</span></label>
                                            <input type="email" name="primary_email"
                                                value={this.state.formInputs.primary_email || localStorage.getItem("edited_primary_email")}
                                                onChange={this.handleInputChange.bind(this)}
                                                placeholder="Your communication email"
                                                className="input-text" />
                                        </p>
                                    </div>
                                </div>

                                {/* <div className="col-md-6 pl-0">
                                    <div className="form-group">
                                        <p>
                                            <label htmlFor="">MATURE CONTENT</label>
                                            <select value={this.state.formInputs.commission_work || localStorage.getItem("edited_commission_work") } name="mature-content" className="mb-25">
                                                <option value="allow">Allow</option>
                                                <option value="disallow">Disallow</option>
                                            </select>
                                        </p>
                                    </div>
                                </div> */}


                            </div>

                            <div className="row mr-0 ml-0 account-preferences">

                                {/*<div className="col-md-6 pl-0">
                                    <div className="form-group">
                                        <p>
                                            <label htmlFor="primary_email">COMMUNICATION EMAIL<span className="text-capitalize" style={{ display: (this.state.formInputs.email_verified) ? "none" : "", color: "#D0021B" }}>(Unverified)</span></label>
                                            <input type="email" name="primary_email"
                                                value={this.state.formInputs.primary_email || localStorage.getItem("edited_primary_email")}
                                                onChange={this.handleInputChange.bind(this)}
                                                placeholder="Your communication email"
                                                className="input-text" />
                                        </p>
                                    </div>
                                </div>
*/}
                                {/* <div className="col-md-6 pl-0">
                                    <div className="form-group">
                                        <p>
                                            <label htmlFor="usd">Profile Tags</label>
                                            <input value={this.state.formInputs.tags}
                                                onChange={this.handleInputChange.bind(this)} name="tags"
                                                placeholder="spanish, artist"
                                                className="input-text" type="text" />
                                        </p>
                                    </div>
                                </div> */}

                            </div>


                            <div className="row mr-0 ml-0 ">
                                <div className="heading-text">
                                    <div className="onboarding-question pl-15">
                                        Account and Privacy
                                        <br />
                                    </div>
                                </div>
                            </div>


                            <div className="row mr-0 ml-0 account-preferences">
                                <div className="col-md-6 pl-0">
                                    <div className="form-group">
                                        <p>
                                            <label htmlFor="primary_email"> EMAIL<span className="text-capitalize" style={{ display: (this.state.formInputs.email_verified) ? "none" : "", color: "#D0021B", fontSize: "10px" }}>(Verification pending)</span></label>
                                            {/* <input value={this.state.formInputs.primary_email}
                                                placeholder="Your email"
                                                onChange={this.handleInputChange.bind(this)} name="primary_email"
                              
                                                className="input-text" type="email" /> */}
                                            <Button className="masterpieces-secondary-buttons mb-4"
                                                onClick={this.sendVerificationEmail.bind(this)}
                                                style={{ width: "100%" }}

                                            >Resend verfication Email</Button>

                                        </p>
                                    </div>

                                    {/* <div style={{ cursor: "pointer" }}
                                        onClick={this.sendVerificationEmail.bind(this)}
                                        className="suggest-text text-underline">Resend verfication Email</div> */}

                                </div>

                                <div className="col-md-6 pl-0">
                                    <div className="form-group">
                                        <p>
                                            <label htmlFor="usd">Password</label>
                                            <Button className="masterpieces-secondary-buttons mb-4"
                                                onClick={this.handleChangePassword.bind(this)}
                                                style={{ width: "100%" }}

                                            >Change Password</Button>
                                        </p>
                                    </div>
                                </div>

                            </div>

                            {/* <div className="row mr-0 ml-0 account-preferences">
                                <div className="col-md-6 pl-0">
                                    <div className="form-group">
                                        <p>
                                            <label htmlFor="usd">Art Requests</label>
                                            <select value={this.state.formInputs.commission_work} onChange={this.handleCommissionWork.bind(this)} name="art-request" placeholder="Commisioning settings" className="mb-25">
                                                <option value={true}>Enable</option>
                                                <option value={false}>Disable</option>
                                            </select>
                                        </p>
                                    </div>

                                </div>


                            </div> */}
                            <div className="form-element inline-sale">
                                <p className="available-for-sale" style={{ textAlign: "left" }}>Art Requests</p>
                                <div className="toggle-button">
                                    <div onClick={() => this.handleArtRequestsToggle()}
                                        className="toggle-button-box">
                                        <div className="toggle-button-oval" style={{
                                            float: (this.state.formInputs.commission_work || localStorage.getItem("edited_commission_work")) ? "right" : "left",
                                            backgroundColor: (this.state.formInputs.commission_work) ? "#BEA57C" : "#BDBDBD"
                                        }}>
                                        </div>
                                    </div >
                                </div>
                            </div>

                            <div className="basic-info-text" style={{ display: (this.state.formInputs.commission_work) ? "" : "none" }}>
                                YourMasterpieces allows artists to take on Commisioning work by listing them in a directory of artists who
                               are available for creating customised artworks. <br />
                                If you are selected for any commission work on our platform, then the agreements of payment will be made between artists and YourMasterpieces.com.
                                    </div>
                            <div className="col-md-12 text-left">

                                <input type="submit" name="submit" className="masterpieces-primary-buttons btn-primary"
                                    onClick={this.saveDetails.bind(this)} value="SAVE DETAILS" style={{ "marginTop": 25 }} />

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Home/profile/editProfile.js